import React from "react";
import { InvoicesView } from "../../components/InvoicesView";

export default function InvoicesPage({ admin = false }) {
  return (
    <div className="max-w-5xl" data-testid="dashboard-invoices">
      <p className="font-script text-[var(--gold)] text-3xl">{admin ? "Every payment" : "Receipts"}</p>
      <h1 className="font-serif font-light text-4xl md:text-5xl mb-2">{admin ? "All invoices" : "Orders & invoices"}</h1>
      <p className="text-[var(--muted)] mb-8">{admin ? "Marketplace, registry, live gifts, plans, attire, deposits and templates." : "What you bought, plus your copy of every sale, deposit and gift paid to you."}</p>
      <InvoicesView admin={admin} />
    </div>
  );
}
